module.exports = __webpack_public_path__ + "img/tripadvisor_button_transparent.76b9e109.png";